import type { FailCodeSubsectionEntity } from '../entities';

import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for looking up fail code subsections within a given section.
 */
export type LookupSubsectionsParams = {
    /** The vehicle model code (e.g. "GUE"). */
    modelCode?: string;

    /** The vehicle model year (e.g. "2024"). */
    modelYear?: string;

    /** The vehicle option/trim code (e.g. "01"). */
    optionCode?: string;

    /** The display name of the parent section. */
    sectionName: string;

    /** The numeric identifier of the parent section. */
    sectionNumber: number;

    /** Optional abort signal for cancellation. */
    signal?: AbortSignal;
};

/**
 * Look up fail code subsections for a vehicle and section in the lookup-by-section flow.
 * Unlike {@link FetchSubsections}, this does not accept a fail code parameter;
 * it is used before a specific fail code is known.
 */
export class LookupSubsections extends StsBackendOperation {
    /**
     * Look up subsections from the API and return them as domain entities.
     *
     * @param params - the vehicle identifiers and parent section
     * @returns the matching subsections as domain entities
     */
    async exec(params: LookupSubsectionsParams): Promise<FailCodeSubsectionEntity[]> {
        const { signal, ...request } = params;
        const response = await this.client.lookupFailCodeSubsections(request, signal);

        if (!response.success) {
            return [];
        }

        return response.data.subsections ?? [];
    }
}
